import React from 'react';
import { XIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { painPoints } from '../../data/landing';
export function Problem() {
  return <section className="bg-ink px-5 py-16 md:py-24" data-id="element-235" data-mp="2whhj7h5w97ue">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1fr_1.1fr] lg:items-center" data-id="element-236" data-mp="2rnddt2ca17vf">
        <div data-id="element-237" data-mp="2mo94mbpcra53">
          <h2 className="text-4xl font-black uppercase leading-[1] tracking-tight text-heading md:text-6xl" data-id="element-238" data-mp="2mosm5rb3bwil">
            ¿Cuántos días más vas a vivir <span className="text-danger" data-id="element-239" data-mp="2cr4czwcqmmgw">así?</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-body" data-id="element-240" data-mp="2cptadzv13krd">
            Tienes un celular. Quieres estar presente. Pero cada vez que desbloqueas la pantalla, entras en una guerra injusta contra 1.000 ingenieros diseñando algoritmos para robarse tu vida, un segundo a la vez.
          </p>
          <p className="mt-6 text-2xl font-extrabold leading-snug text-heading" data-id="element-241" data-mp="6xny6n3r1i1o">
            Aprende el sistema para recuperar hasta 4 horas de tu tiempo <Highlight data-id="element-242" data-mp="14b23mmf3qvqp">No es magia. Es un Sistema.</Highlight>
          </p>
        </div>

        <ul className="divide-y divide-line overflow-hidden rounded-3xl border border-line bg-surface" data-id="element-243" data-mp="14deob7c8vk7g">
          {painPoints.map(p => <li key={p} className="flex items-start gap-4 px-6 py-4" data-id="element-244" data-mp="vax22swlarkg">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger/15" data-id="element-245" data-mp="vcq9wbixvhu1">
                <XIcon className="h-4 w-4 text-danger" strokeWidth={3} aria-hidden="true" data-id="element-246" data-mp="1nzb5xpad0i3x" />
              </span>
              <span className="text-base font-medium text-body md:text-lg" data-id="element-247" data-mp="1s1662qgk0pg4">{p}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}